import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import FieldError from '../FieldError';

export default function CompanyStep({ formData, companies, errors, handleChange }) {
  return (
    <div>
      <label className="text-blue-500 text-2xl font-bold mb-6 block">Company</label>
      <Select value={formData.company} onValueChange={(value) => handleChange('company', value)}>
        <SelectTrigger
          className={`w-full bg-white h-12 text-lg ${errors.company ? 'border-red-500' : ''}`}
          data-testid="intake-company-trigger"
        >
          <SelectValue placeholder="Select" />
        </SelectTrigger>
        <SelectContent>
          {companies.map((comp) => (
            <SelectItem key={comp.name} value={comp.name}>
              {comp.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <FieldError message={errors.company} />
    </div>
  );
}
